module.exports = __webpack_public_path__ + "static/media/menu.927b32ed.svg";